/**
 * Normalize bazaar fulfill-outbound prefilled products for CreateOutbound stock lines.
 * Accepts flat product objects or nested `{ product, quantity, ... }` shapes.
 */
export const mapPrefilledOutboundProducts = (products) =>
  (products || []).map((prod) => {
    const product = prod.product || prod;
    return {
      _id: prod._id || product._id,
      sku: prod.sku || product.sku || prod.externalId || product.externalId,
      externalId: prod.externalId || product.externalId,
      name: prod.name || product.name,
      quantity: prod.quantity,
      stock: prod.stock || product.stock,
      size: prod.size || product.size,
      color: prod.color || product.color,
      weight: prod.weight || product.weight,
    };
  });

/**
 * Fill missing SKUs on prefilled stock lines from the loaded product catalog.
 * Returns the original array reference when nothing changes.
 */
export const enrichStockItemsFromProducts = (stockItems, products) => {
  if (!products?.length || !stockItems?.length) {
    return stockItems;
  }
  let changed = false;
  const next = stockItems.map((item) => {
    if (item.sku || item.externalId) {
      return item;
    }
    const found = products.find((product) => product._id === item._id);
    if (!found) {
      return item;
    }
    changed = true;
    return {
      ...item,
      sku: found.sku || found.externalId,
      externalId: found.externalId,
      name: item.name || found.name,
      stock: item.stock || found.stock,
      size: item.size || found.size,
      color: item.color || found.color,
      weight: item.weight || found.weight,
    };
  });
  return changed ? next : stockItems;
};
